import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { CHAIN_ID_PER_NETWORK_URL_PATH, NATIVE_TOKEN_SYMBOL_PER_CHAIN } from '@/constants/chain';

import { ChainAddress, isChainAddress } from '@/utils/models';
import { getNativeAddressFromSymbol } from '@/utils/multichain';
import { TokenInfo } from '@/utils/token.types';

export const useActiveToken = () => {
  const router = useRouter();

  const [rawAddress] = (router.query.contractAddresses as string[]) || [];
  const rawChainId = router.query.chainId as string | undefined;
  const chainId = CHAIN_ID_PER_NETWORK_URL_PATH[rawChainId || 1] ?? parseInt(rawChainId || '1', 10);
  const address: ChainAddress | undefined =
    getNativeAddressFromSymbol(
      rawAddress === 'native' ? NATIVE_TOKEN_SYMBOL_PER_CHAIN[chainId] : rawAddress,
      chainId,
    ) ??
    (rawAddress !== undefined && isChainAddress(rawAddress)
      ? (rawAddress as ChainAddress)
      : undefined);

  const activeToken: TokenInfo | undefined = useMemo(
    () => (address ? { address, chainId } : undefined),
    [address, chainId],
  );

  if (!router.isReady) return;

  return activeToken;
};
